module.exports = __webpack_public_path__ + "static/paragraph-2-mobile-b13b85929c891c4bec1c2ef70b238bf2.svg";